import { atom } from "recoil";
import { RiskDataType } from "../types/RiskInterface";
export const addStateRisk = atom({
  key: "addStateRisk",
  default: false,
});
export const editStateRisk = atom({
  key: "editStateRisk",
  default: false,
});
export const rowEditRisk = atom<RiskDataType | undefined>({
  key: "rowEditRisk",
  default: undefined,
});

export const selectedRowsStateRisk = atom<RiskDataType[]>({
  key: "selectedRowsStateRisk",
  default: [],
});

export const riskFilterText = atom({
  key: "riskFilterText",
  default: "",
});

export const savingRisk = atom({
  key: "savingRisk",
  default: false,
});
export const riskFetching = atom({
  key: "riskFetching",
  default: true,
});
